import Nullstack from 'nullstack';
export default function IconSteeringWheel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-steering-wheel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "9"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "14",
    x2: "12",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "12",
    x2: "3.25",
    y2: "10"
  }), "   ", Nullstack.element("line", {
    x1: "14",
    y1: "12",
    x2: "20.75",
    y2: "10"
  }), " ");
}